
/* injects from baggage-loader */

'use strict';

import ExpressEarlyInterestModalController from './expressearlyinterestmodal.controller';
import ExpressEarlyInterestModalTemplate from './expressearlyinterestmodal.html';

export default class ExpressEarlyInterestModalComponent {
		constructor() {
				this.templateUrl = ExpressEarlyInterestModalTemplate;
				this.controller = ExpressEarlyInterestModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}
